import React, { Component } from 'react';
import {getLogScale} from 'components/effects/SpectrumUtils.js';
import {getGainVolume} from 'utils/getVolume.js';

const HEIGHT = 45;
const UPDATE_RATE = 100;
const FACTOR = 0.8;
class TrackMeter extends Component {
    constructor(props) {
        super(props);

        this.state = {
            height: 0,
            referenceHeight: this.fromDecibel(0),
        };
    }

    fromDecibel(db, min=-80,max=6) {
        if (db < -80) {
            return 0;
        }
        return HEIGHT * Math.pow((db - min) / (max - min), 2);
    }

    componentDidMount() {
        this.timer = setInterval(() => {
            let value = this.props.meter.getLevel();
            this.setState({
                isRed: value > 0,
                height: Math.min(60, this.fromDecibel(value)), 
            });
        }, UPDATE_RATE);
    }

    componentWillUnmount() {
        clearInterval(this.timer);
    }

    render() {
        let style = {
            height: this.state.height
        };

        let referenceStyle = {
            height: this.state.referenceHeight,
        };

        let meterClassName = 'track-meter-value';
        if (this.state.isRed) {
            meterClassName += ' is-red';
        }

        return (
            <div className="track-meter">
              <div className={meterClassName} style={style}></div>
              <div className="track-meter-reference" style={referenceStyle}></div>
            </div>
        );
    }
}

export default TrackMeter;
